export default [
  {
    path: "/platformConfigurations/cashoutMethods",
    component: () => import(/* webpackChunkName: "layout" */ "../layout"),

    children: [
      {
        path: ":id",
        props: true,
        name: "platform.cashoutMethods.show",
        component: () => import(/* webpackChunkName: "platform.cashoutMethods" */ "./show.vue"),
      },
    ],
  },
];
